import { type FieldConfig, useField } from 'formik';

import TextareaUI, { type TextareaProps } from './Textarea';

type Props = TextareaProps & FieldConfig;

/**
 * An Formik controlled Textarea component.
 */
const Textarea = ({ ...props }: Props) => {
  const [field, meta] = useField(props);

  return <TextareaUI {...field} {...props} error={meta.touched ? meta.error : undefined} />;
};

export default Textarea;
